/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.ExportDeclarationResponseDto>>;
export function request(
  params: API.tms.exportDeclaration.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
